(function () {
  let isAddingRedo = false;
  let redoSubmitting = false;

  function initRedoCartReturns() {
    const cartForm = document.getElementById('cart');
    const redoWrapper = document.querySelector('[data-redo-returns]');

    if (!cartForm || !redoWrapper) return;

    const variantId = redoWrapper.dataset.redoVariantId;
    if (!variantId) return;

    cartForm.addEventListener('submit', function (e) {
      if (redoSubmitting) return;

      const submitter = e.submitter;
      if (!submitter || submitter.getAttribute('name') !== 'checkout') return;

      const policyCheckbox = document.getElementById('cart-policy-agreement-checkbox');
      if (policyCheckbox && !policyCheckbox.checked) return;

      const redoCheckbox = document.getElementById('cart-redo-returns-checkbox');
      if (!redoCheckbox || !redoCheckbox.checked) return;

      if (redoWrapper.dataset.redoInCart === 'true' || isAddingRedo) return;

      e.preventDefault();
      e.stopPropagation();
      isAddingRedo = true;

      fetch(`${window.routes.cart_add_url}`, {
        ...fetchConfig(),
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          isAddingRedo = false;

          if (response.status) {
            alert(window.cartStrings?.error || 'There was an error while updating your cart. Please try again.');
            return;
          }

          redoSubmitting = true;
          const checkoutInput = document.createElement('input');
          checkoutInput.type = 'hidden';
          checkoutInput.name = 'checkout';
          cartForm.appendChild(checkoutInput);
          cartForm.submit();
        })
        .catch(() => {
          isAddingRedo = false;
          alert(window.cartStrings?.error || 'There was an error while updating your cart. Please try again.');
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRedoCartReturns);
  } else {
    initRedoCartReturns();
  }
})();
